var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgIconlessbig = function SvgIconlessbig(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7h15v1H0z",
    fill: "#1F140F",
    fillRule: "evenodd"
  })));
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTVweCIgaGVpZ2h0PSIxNXB4IiB2aWV3Qm94PSIwIDAgMTUgMTUiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+DQoJPHRpdGxlPg0KCQlpY29ubWludXMNCgk8L3RpdGxlPg0KCTxkZXNjPg0KCQlDcmVhdGVkIHdpdGggU2tldGNoLg0KCTwvZGVzYz4NCgk8ZyBpZD0iaWNvbm1pbnVzIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4NCgkJPHBhdGggZD0iTTAsNyBMMTUsNyBMMTUsOCBMMCw4IFoiIGlkPSJDb21iaW5lZC1TaGFwZSIgZmlsbD0iIzFGMTQwRiI+DQoJCTwvcGF0aD4NCgk8L2c+DQo8L3N2Zz4NCg==";
export { SvgIconlessbig as ReactComponent };